import { Box } from "@mui/material";
// import { useState } from "react";
import { P2pReqvizTable } from "src/components/p2p/reqvizity/P2pReqvizTable";


export const P2pReqvizityPage = () => {
    // const [loadTable, setLoadTable] = useState(false);

    return (
        <>
            <Box>
                <P2pReqvizTable />
            </Box>
        </>
    )
}
